import * as React from 'react';
import {Trans, useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';
import {Asset, AssetGroup} from '@deviceinsight/ng-ui-api-client';
import {Button, Modal} from '@deviceinsight/ng-ui-basic-components';
import SingleAssetSelectionTable from '../../../modules/search/asset/SingleAssetSelectionTable';

type OwnProps = {
	assetGroup: AssetGroup | null | undefined;
	onAssetSelect: (arg0: Asset) => void;
	asset: Asset | null | undefined;
	canEdit: boolean;
};
type Props = OwnProps;

const RuleAsset: React.FC<Props> = ({asset, assetGroup, canEdit, onAssetSelect}) => {
	const {t} = useTranslation();
	const [isSelecting, setIsSelecting] = React.useState(false);

	const handleSelectAsset = React.useCallback(
		(asset: Asset) => {
			setIsSelecting(false);
			onAssetSelect(asset);
		},
		[onAssetSelect]
	);

	const handleCancel = React.useCallback(() => {
		setIsSelecting(false);
	}, []);

	return (
		<div className="rule-asset" data-testid="asset-selection">
			<Button onClick={() => setIsSelecting(true)} disabled={!canEdit} title={asset ? asset.name : ''}>
				{asset ? (
					<span title={asset.name}>{asset.name}</span>
				) : (
					<Trans i18nKey="ruleengine.conditions.selectasset">Select Asset</Trans>
				)}
			</Button>
			{isSelecting && (
				<Modal
					width="900px"
					header={
						t('ruleengine.conditions.selectasset', {
							defaultValue: 'Select Asset'
						}) as string
					}
					content={
						<SingleAssetSelectionTable
							assetGroup={assetGroup ?? undefined}
							onSelectAsset={handleSelectAsset}
						/>
					}
					footer={
						<Button onClick={handleCancel}>
							<Trans i18nKey="general.actions.cancel">Abbrechen</Trans>
						</Button>
					}
				/>
			)}
		</div>
	);
};

export default RuleAsset;
